<template>
  <div class="notes">
    <transition name="fade">
      <ButtonNew :text="'Escribe un nuevo apunte'" v-if="!showBox"  @change="showCreateBox"/>
    </transition>
    <EmptyState
      v-if="GET_NOTES_COURSE.length === 0 && !showBox"
      :textEmpty="'Aún no has creado apuntes en esta clase'"
      :textDescript="'Toma apuntes mientras vas aprendiendo'"
    ></EmptyState>
    <div class="interaction">
      <transition name="fade">
        <NoteCreateBox
          v-if="showBox"
          :disabled="GET_LOADDING"
          :time="time"
          :placeholder="'Escribe un apunte ...'"
          @saveNote="saveNote"
          @change="showBox=false"
        ></NoteCreateBox>
      </transition>
      <div v-for="data in GET_NOTES_COURSE" :key="data.id">
        <NoteBox :item="data" @change="showBox=true"></NoteBox>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonNew from "../components/ButtonNew.vue";
import EmptyState from "../components/EmptyState.vue";
import NoteBox from "../components/NoteBox.vue";
import NoteCreateBox from "../components/NoteCreateBox.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ButtonNew,
    EmptyState,
    NoteBox,
    NoteCreateBox,
  },
  data() {
    return {
      showBox:false,
    };
  },
  props:{
    time: {
      default: 0
    }
  },
  computed: {
    ...mapGetters("notes", ["GET_NOTES_COURSE", "GET_LOADDING"]),
  },
  methods: {
    showCreateBox(){
        this.showBox=true
        this.$store.commit("notes/SET_NOTE_EDIT", false);
    },
    saveNote(template) {
      let body = {
        content: template,
        mounted_course_id: this.$route.params.id,
        time: this.secondsToString(this.time),
      };
      this.$store.dispatch("notes/post_notes_course", {
        _body: body,
      });
    },
    secondsToString(seconds) {
      let hour = Math.floor(seconds / 3600);
      hour = (hour < 10)? '0' + hour : hour;

      let minute = Math.floor((seconds / 60) % 60);
      if(parseInt(hour)>0)
        minute = (minute < 10)? '0' + minute : minute;

      let second = seconds % 60;
      second = (second < 10)? '0' + second : second;

      if(parseInt(hour)>0)
        return hour + ':' + minute + ':' + second;
      else 
        return minute + ':' + second;
    }
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
